/**
 *@author yudeping
 *历史值
 */

import template from './history.html';
import './history.scss';
import Component from "../../../lib/component";
let config = {
    template: template,
    data: {
    },
    actions:{

    },
    firstAfterRender(){

    },
}
let HistoryComponent=Component.extend(config);
export default {
    el:null,
    show:function (config) {
        let component = new HistoryComponent(config);
        this.el = $('<div class="History-dialog">').appendTo(document.body);
        component.render(this.el);
        this.el.erdsDialog({
            title: '修改历史',
            width: 800,
            height: 600,
            modal: true,
            close: function() {
                $(this).erdsDialog('destroy');
                component.destroySelf();
            }
        });
        this.el.parent().css('z-index','100000');
    },
    hide:function () {
        this.el.erdsDialog('close');
    }
};


// WEBPACK FOOTER //
// app/components/form/history/history.js